import store from "@/store/";

function emailIsUnique(newEmail) {
	// TODO: Micheal Shirk says to...
	// TODO: UPDATE to use .every() instead of for() loop below
	// console.log("store.getters.people", store.getters.people)
	// console.log("bool:", [...store.getters.people].every(person => person.email != newEmail))
	// return [...store.getters.people].every(person => person.email != newEmail)

	// TODO: UPDATE to remove for() loop
	let isUnique;
	for (const person in store.getters.people) {
		isUnique = (store.getters.people[person].email !== newEmail);
		if (!isUnique) {
			return isUnique;
		}
	}
	return isUnique;
}
// function fieldIsNull(field) {
// 	return !!field || field;
// }
const validationRules = {
	nameValid: [
		v => (v && v.length <= 35) || "Name must be less than 35 characters"
	],
	nameRequiredValid: [
		v => !!v || "Name is required",
		v => (v && v.length <= 35) || "Name must be less than 35 characters"
	],
	fullNameRequiredValid: [
		v => !!v || "First and Last Name are required",
		v =>
			/^(.*\s+.*)+$/.test(v) ||
    "First and Last Name are required",
	],
	emailValid: [
		v =>
			/((^$|^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$)?)/.test(v) ||
    "E-mail must be valid"
	],
	emailRequiredValid: [
		v => !!v || "E-mail is required",
		v =>
			/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
    "E-mail must be valid"
	],
	emailRequiredValidUnique: [
		v => !!v || "E-mail is required",
		v =>
			/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
    "E-mail must be valid",
		v => emailIsUnique(v) || "Email already exists"
	],
	phoneValid: [
		v =>
			/((^$|([(][0-9]{3}[)] [0-9]{3}-[0-9]{4}))?)/.test(v) ||
    "Phone must be valid. Example format: (555) 555-5555",
	],
	phoneRequiredValid: [
		v => !!v || "Phone Number is required",
		v =>
			/[(][0-9]{3}[)] [0-9]{3}-[0-9]{4}/.test(v) ||
    "Phone must be valid. Example format: (555) 555-5555",
	],
	streetRequiredValid: [
		v => !!v || "Street is required",
		v => (v && v.length <= 35) || "Street must be less than 35 characters"
	],
	cityRequiredValid: [
		v => !!v || "Street is required",
		v => (v && v.length <= 35) || "City must be less than 35 characters"
	],
	zipRequiredValid: [
		// v => !!v || "Street is required",
		v =>
			/^(\d{5})?$/.test(v) ||
    "Zip must be valid.",
	],
	relationshipRequiredValid: [
		v => !!v || "Relationship is required",
		v => (v && v.length <= 35) || "Relationship must be less than 35 characters"
	],
	idRequiredValid: [
		v => !!v || "ID is required",
		v => (v && v.length == 3) || "ID must be 3 digits. Example: 023",
		v =>
			/\d{3}/.test(v) || "ID must be 3 digits. Example: 023"
	],
	dateValid: [
		v =>
			/^$|(^((0|1)\d{1})[/]((0|1|2|3)\d{1})[/]((19|20)\d{2}))/.test(v) || "Use the following date format. 09/23/1970"
	],
	dateRequiredValid: [
		v => !!v || "Date is required",
		// v => (v && v.length == 3) || "ID must be 3 digits. Example: 023",
		v =>
			/^((0|1)\d{1})[/]((0|1|2|3)\d{1})[/]((19|20)\d{2})/.test(v) || "Use the following date format. 09/23/1970"
	],
};
export {
	emailIsUnique,
	validationRules
};


// WEBPACK FOOTER //
// ./src/vue-service-validation.js